import React from "react";
import styles from "./BorderContainerWithTitle.module";

export interface IBorderContainerWithTitle {
  className?: string;
  title?: string | React.ReactNode;
  children: React.ReactNode;
}

export const BorderContainerWithTitle: React.FC<IBorderContainerWithTitle> = ({
  className,
  title,
  children,
}) => {
  return (
    <div className={`${styles.wrapper} ${className}`}>
      <h3 className={styles.title}>{title}</h3>
      {children}
    </div>
  );
};
